import { render, staticRenderFns } from "@/modules/ThirdParty/templates/third-party-detail.html?vue&type=template&id=3da31eda&scoped=true&"
import script from "@/modules/ThirdParty/scripts/third-party-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/ThirdParty/scripts/third-party-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/ThirdParty/styles/third-party-detail.scss?vue&type=style&index=0&id=3da31eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da31eda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
